module.exports = __webpack_public_path__ + "img/pdf-icon.76036a91.png";